module.exports = __webpack_public_path__ + "img/145.e0603aee.gif";